
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatabaseDownstreamMetricsQueryVariables, DatabaseDownstreamMetricsQuery, MetricsDisplayGridRowDataFragment, DatabaseDownstreamMetricsFilteredByTableQueryVariables, DatabaseDownstreamMetricsFilteredByTableQuery, MetricSortOrder , DatabaseDownstreamMetricsFilteredByTableDocument , DatabaseDownstreamMetricsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { getRowDataForMetric, MetricsDisplayGrid, MetricsDisplayGridRowData } from '../sharedDisplayGrid/MetricsDisplayGrid';
import { MetricsValidSortFields } from '../sorting/sortProviders/MetricsGridSortProvider';

type QueryVariables = DatabaseDownstreamMetricsQueryVariables;
type QueryResults = DatabaseDownstreamMetricsQuery;
type QueryResultListNode = MetricsDisplayGridRowDataFragment;
type GridRowData = MetricsDisplayGridRowData;

type QueryVariablesWithFilter = DatabaseDownstreamMetricsFilteredByTableQueryVariables;
type QueryResultsWithFilter = DatabaseDownstreamMetricsFilteredByTableQuery;
type QueryResultListNodeWithFilter = MetricsDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.databases[0]?.downstreamMetricsConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  return resultData?.tables[0]?.downstreamMetricsConnection;
}

export type DatabaseDownstreamMetricsQueryGridProps =
  GridSortProps<MetricsValidSortFields> & {
    readonly databaseId: string;
    readonly filteredTableId: string | null;
    readonly rowCount: number | null;
  };

export function DatabaseDownstreamMetricsQueryGrid(props: DatabaseDownstreamMetricsQueryGridProps): JSX.Element {

  const emptyGridMessage = Messages.EmptyDownstreamMetricsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredMetricsLineageGridMessage();

  return (
    props.filteredTableId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNodeWithFilter, GridRowData>
        queryGql={DatabaseDownstreamMetricsFilteredByTableDocument}
        partialQueryVariables={{ tableId: props.filteredTableId, orderBy: props.orderBy as MetricSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForMetric}
      >
        {({ rowStore }) => <MetricsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={DatabaseDownstreamMetricsDocument}
        partialQueryVariables={{ databaseId: props.databaseId, orderBy: props.orderBy as MetricSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForMetric}
      >
        {({ rowStore }) => <MetricsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    )
  )
}
